import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.isOpen = false
    this.handleOutside = this.handleOutside.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    this.isOpen ? this.hide() : this.show()
  }

  show() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("is-open")
      this.isOpen = true
      document.addEventListener("click", this.handleOutside, { capture: true })
    }
  }

  hide() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("is-open")
      this.isOpen = false
      document.removeEventListener("click", this.handleOutside, { capture: true })
    }
  }

  handleOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}


